
import React from 'react';
import './errorPage.css';

const ErrorPage = () => (
	<div className="row center-align-container">
		<div className="box-body">
			<h3 className="center-align-container">Error</h3>
			<div id="DivAssessmentMaster">An error occurred while processing your request.</div>
			<br />
			<h5 id="lblAssessmentName"></h5>
			<div id="DivAssessmentDetail"></div>
			<br />
		</div>
	</div>
);

export default ErrorPage;
